import styles from './quienes-somos-page.module.scss';
import React from "react";

import Hero from "../../components/hero/hero";
import { HERO_WAVE_PAGE } from "../../components/hero/waves";

export interface QuienesSomosPageProps {
  name?: string;
  classes?: string;
}

const valores = [
  {
    titulo: "Calidad ante todo",
    copy: "Nos aseguramos de que cada producto cumpla con los estándares más altos de frescura y sabor.",
    imagen: "/assets/productos/manchego.jpg",
  },
  {
    titulo: "Transparencia y confianza",
    copy: "Creemos en procesos claros, honestos y responsables.",
    imagen: "/assets/productos/oaxaca.jpg",
  },
  {
    titulo: "Calidez humana",
    copy: "Servimos con cercanía, trato amable y atención personalizada.",
    imagen: "/assets/productos/gouda.jpg",
  },
  {
    titulo: "Respeto por lo artesanal",
    copy: "Valoramos lo hecho con dedicación, tradición y manos expertas.",
    imagen: "/assets/productos/panela.jpg",
  },
];

const cremeriaCards = [
  {
    l1: "Come",
    l2: "rico...",
    copy: "En Cremería Los Pinos encontrarás nuestros productos y podrás probar alguno de los ricos platillos que se preparan con nuestra calidad, con un excelente servicio al momento y si lo prefieres, para llevar.",
    imagen: "/assets/productos/manchego.jpg",
  },
  {
    l1: "Come",
    l2: "saludable...",
    copy: "Usamos los mejores ingredientes de la región, naturales, sin conservadores ni grasas vegetales, para que tú tengas la tranquilidad de que los alimentos que hacemos llegar hasta tus manos son saludables.",
    imagen: "/assets/productos/panela.jpg",
  },
  {
    l1: "¡Come",
    l2: "bien!",
    copy: "Porque comer es algo que hacemos todos los días y tú te mereces solo lo mejor para tener una vida plena y disfrutar de lo que hacemos todos los días…",
    imagen: "/assets/productos/gouda.jpg",
  },
];

/**
 * ¿Quiénes somos? (Figma `110:399`, 1920×5799):
 * Esencia · Historia (banda) · Visión y Misión · Valores (banda) · Cremería Los Pinos.
 */
export default class QuienesSomosPage extends React.Component<QuienesSomosPageProps> {
  static jsClass = "QuienesSomosPage";
  static defaultProps: Partial<QuienesSomosPageProps> = {
    name: "mbQuienesSomos",
  };

  render(): React.ReactNode {
    const { classes } = this.props;

    return (
      <div className={styles['mb-home'] + (classes ? ' ' + classes : '')}>
        <Hero
          src="/assets/hero/factory-2.jpg"
          title="¿Quiénes somos?"
          align="end"
          wave={HERO_WAVE_PAGE}
        />

        {/* ── Nuestra esencia ─────────────────────────────────────────────── */}
        <section className={styles['mb-esencia']}>
          <div className={styles['mb-wrap']}>
            <div className={styles['mb-esencia__grid']}>
              <h2 className={styles['mb-h2']}>Nuestra esencia</h2>
              <img
                className={styles['mb-esencia__img']}
                src="/assets/design/quienes-rect22.webp"
                alt="Quesos artesanales MangiBone"
              />
            </div>
          </div>
        </section>

        {/* ── Nuestra historia ───────────────────────────────────────────── */}
        <section className={styles['mb-historia']}>
          <div className={styles['mb-wrap']}>
            <h2 className={styles['mb-h2'] + ' ' + styles['mb-h2--cream'] + ' ' + styles['mb-h2--center']}>
              Nuestra historia
            </h2>
            <div className={styles['mb-historia__cols']}>
              <p>
                Agroindustrias MangiBone es una microempresa tipo industrial de capital
                privado, registrada como persona física por el Ing. Agro. Alfredo Islas
                Blancas. Fundada en el año 2008 y dedicada a la elaboración de productos
                en el sector alimentario destinados al consumo humano, ofrece una alta gama
                de productos: yogurt de leche de vaca y yogurt de leche de soya en sus
                diferentes presentaciones de sabores y gramaje; chorizo de carne de cerdo
                ahumado y chorizo de soya, y queso de soya tipo tofu en tres diferentes
                presentaciones de sabor. Su cobertura de distribución es a nivel regional y
                nacional distribuyendo en los estados de Hidalgo y Ciudad de México. Desde su
                consolidación, la empresa MangiBone busca satisfacer las necesidades de sus
                consumidores ofreciendo productos que cumplan con las normas de calidad e
                inocuidad que se establecen en la legislación mexicana, con el objetivo
                primordial de cuidar la salud de sus consumidores y ofreciendo alternativas
                de consumo con un alto valor nutricional.
              </p>
              <p>
                El dinamismo de la organización ha impulsado a la implementación de un
                Sistema de Gestión de la Calidad, enfocado a certificar todas las líneas de
                producción que la conforman, esto para dar mejor respuesta al mercado en
                cuanto a la calidad de los productos que se elaboran, cumpliendo con cada uno
                de los estándares que se manejan dentro de las normas de calidad y buscando
                la satisfacción del cliente. La Dirección de la empresa está decidida a
                realizar los esfuerzos e inversiones necesarias para mejorar continuamente la
                calidad de los productos que ofrece y convertirse en una opción de consumo
                saludable para la población mexicana en general. Sus oficinas e instalaciones
                están situadas en C. 3ra Cerrada del Tezontle, No. 21, Fraccionamiento Vista
                Real, C.P. 43700, Tulancingo de Bravo, Hidalgo.
              </p>
            </div>
          </div>
        </section>

        {/* ── Visión y Misión ────────────────────────────────────────────── */}
        <section className={styles['mb-vision']}>
          <div className={styles['mb-wrap']}>
            <div className={styles['mb-vision__grid']}>
              <div className={styles['mb-vision__text']}>
                <h3 className={styles['mb-h3']}>Nuestra visión</h3>
                <p>
                  Ofrecer alternativas de consumo que exhorten a la ciudadanía de México a
                  tener una mejor calidad de vida mediante el consumo de productos saludables
                  con un concepto de propiedades curativas y beneficios nutricionales.
                </p>
                <h3 className={styles['mb-h3']}>Nuestra misión</h3>
                <p>
                  Satisfacer las necesidades de los consumidores elaborando y comercializando
                  productos que contribuyan a llevar un estilo de vida saludable con ventajas
                  nutricionales y de forma accesible.
                </p>
              </div>
              <div className={styles['mb-vision__media']}>
                <img
                  src="/assets/design/quienes-rect.webp"
                  alt="MangiBone — proceso y tradición"
                />
                <span className={styles['mb-vision__play']} aria-hidden="true">
                  <svg viewBox="0 0 24 24">
                    <path fill="currentColor" d="M8 5v14l11-7z" />
                  </svg>
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* ── Nuestros valores ───────────────────────────────────────────── */}
        <section className={styles['mb-valores']}>
          <div className={styles['mb-wrap']}>
            <h2 className={styles['mb-h2'] + ' ' + styles['mb-h2--cream'] + ' ' + styles['mb-h2--center']}>
              Nuestros valores
            </h2>
            <div className={styles['mb-valores__grid']}>
              {valores.map((valor) => (
                <div className={styles['mb-valores__item']} key={valor.titulo}>
                  <img
                    className={styles['mb-valores__img']}
                    src={valor.imagen}
                    alt={valor.titulo}
                    loading="lazy"
                  />
                  <h3 className={styles['mb-valores__title']}>{valor.titulo}</h3>
                  <p className={styles['mb-valores__copy']}>{valor.copy}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ── Cremería Los Pinos ─────────────────────────────────────────── */}
        <section className={styles['mb-cremeria']}>
          <div className={styles['mb-wrap']}>
            <div className={styles['mb-cremeria__grid']}>
              {cremeriaCards.map((card) => (
                <article className={styles['mb-cremeria__card']} key={card.l2}>
                  <h3 className={styles['mb-cremeria__title']}>
                    {card.l1} <span>{card.l2}</span>
                  </h3>
                  <p className={styles['mb-cremeria__copy']}>{card.copy}</p>
                  <img
                    className={styles['mb-cremeria__img']}
                    src={card.imagen}
                    alt={card.l2}
                    loading="lazy"
                  />
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    );
  }
}
